import { useIntl } from "react-intl";
import { NavLink } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
//Components
import { Grid, Typography, Container, Paper, Divider, Icon } from "@mui/material";
import { Button, Tooltip } from "@gpstrackit/react-controls";

import DataViewInfiniteScroll from 'Components/DataViewInfiniteScroll';

//Views
import CreateUnsubscribedContact from 'Modules/unsubscribedContacts/.components/createUnsubscribedContact';
import DeleteUnsubscribedContact from 'Modules/unsubscribedContacts/.components/deleteUnsubscribedContact';
import RawMessageView from 'Modules/devices/.components/rawMessageView'

//Notification
import { NotificationManager } from "Components/Notifications";

//Actions
import {
    createUnsubscribedContactOpenModal,
    deleteUnsubscribedContactOpenModal,
    searchEntityRequest,
    rawMessageViewOpenModal
} from 'Redux/actions';

//helpers
import { getDateFormatted, getPMUser } from 'Core/data/Helpers';

//Permission
import { HasPermission } from "Core/security"

const UnsubscribedContactsMain = (props) => {
    const { messages } = useIntl();
    const tableRef = useRef();
    const dispatch = useDispatch();


    const openModalCreate = useSelector(state => state.createUnsubscribedContactRedux.openModal);
    const openModalDelete = useSelector(state => state.deleteUnsubscribedContactRedux.openModal);
    const open = useSelector(state => state.rawMessageViewRedux.openModal)
    const pmUsers = useSelector(state => state.generalRedux.pmUsers);
    const user = useSelector(state => state.securityRedux.user);
    const lang = useSelector(state => state.commonRedux.language);

    const [reportedOptions, setReportedOptions] = useState([
        {
            id: "30",
            label: messages[`unsubscribed_contacts_main_30`]
        },
        {
            id: "50",
            label: messages[`unsubscribed_contacts_main_50`]
        },
        {
            id: "70",
            label: messages[`unsubscribed_contacts_main_70`]
        },
        {
            id: "100",
            label: messages[`unsubscribed_contacts_main_100`]
        },
        {
            id: "200",
            label: messages[`unsubscribed_contacts_main_200`]
        }]);

    const [total, setTotal] = useState(0);
    const [columns, setColumns] = useState([
        {
            key: "reason_details",
            title: "",
            show: true,
            locked: true,
            width: 30,
            icon: true,
            render: (item) => {
                let title = null
                let jsonValue = null
                try {
                    jsonValue = item?.jsonValue
                    if (jsonValue) {
                        jsonValue = JSON.parse(JSON.parse(item?.jsonValue))
                        if (!_.isObject(jsonValue))
                            jsonValue = JSON.parse(jsonValue)
                        title = item?.reason
                    }
                    let reported = reportedOptions.find(x => x.id == item?.reason)
                    if (jsonValue && item?.reason && reported) {
                        title = messages[`unsubscribed_contacts_main_${item?.reason}`]
                    }

                    if (title === null || typeof title === 'undefined')
                        title = messages["unsubscribed_contacts_main_details"]
                } catch (error) {

                }
                return (
                    <div>
                        {
                            jsonValue &&
                            <Tooltip title={messages["unsubscribed_contacts_main_details"]}>
                                <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon fs-20" onClick={() => {
                                    dispatch(rawMessageViewOpenModal(true, jsonValue || "", title))
                                }}>
                                    remove_red_eye
                                </Icon>
                            </Tooltip>
                        }
                    </div>
                )
            }
        },
        {
            key: "id",
            field: "id",
            title: messages['unsubscribed_contacts_main_id'],
            show: true,
            sort: true,
            width: 40,
            export: true,
            functionString: 'return row?.id',
            code: "unsubscribed_contacts_main_id",
            render: (item) => {
                return (<span>{item.id}</span>)
            }
        },
        {
            key: "to",
            field: "to",
            title: messages['unsubscribed_contacts_main_to'],
            show: true,
            sort: true,
            width: 300,
            export: true,
            functionString: 'return row?.to?.replace("sms_","").replace("email_","") || ""',
            code: "unsubscribed_contacts_main_to",
            render: (item) => {
                let formatted = item?.to?.replace("sms_", "").replace("email_", "") || ""
                return (<span>{formatted}</span>)
            }
        },
        {
            key: "via",
            title: messages['unsubscribed_contacts_main_via'],
            show: true,
            width: 120,
            export: true,
            functionString: `return row?.to?.includes("@") ? "${messages["unsubscribed_contacts_main_via_email"]}" : "${messages["unsubscribed_contacts_main_via_sms"]}";`,
            code: "unsubscribed_contacts_main_via",
            render: (item) => {
                return <span>{item?.to?.includes("sms_") ? messages["unsubscribed_contacts_main_via_sms"] : messages["unsubscribed_contacts_main_via_email"]}</span>
            }
        },
        {
            key: "source",
            field: "source",
            title: messages['unsubscribed_contacts_main_source'],
            show: true,
            sort: true,
            width: 200,
            export: true,
            functionString: 'return row?.source',
            code: "unsubscribed_contacts_main_source",
            render: (item) => {
                return <span>{item?.source}</span>
            }
        },
        {
            key: "reason",
            title: messages['unsubscribed_contacts_main_reason'],
            show: true,
            width: 200,
            export: true,
            functionString: `
                
                let reasonMsg = row?.reason
                let reportedOptions = ${JSON.stringify(reportedOptions)}
                let option = reportedOptions.find(x => x.id == row?.reason)
                if (row?.jsonValue && row?.reason && option) {
                    reasonMsg = option.label
                }
                return reasonMsg || ""
            `,
            code: "unsubscribed_contacts_main_reason",
            render: (item) => {
                let reasonMsg = item?.reason
                if (item?.jsonValue && item?.reason && reportedOptions.find(x => x.id === item?.reason)) {
                    reasonMsg = messages[`unsubscribed_contacts_main_${item?.reason}`]
                }

                return <span>{reasonMsg || ""}</span>
            }
        },
        {
            key: "createdOn",
            field: "createdOn",
            title: messages['unsubscribed_contacts_main_created_on'],
            show: true,
            resize: true,
            width: 200,
            sort: true,
            export: true,
            functionString: 'return row?.createdOn && (new Date(`${row?.createdOn}`)).toISOString().slice(0, 19).replace("T", " ")',
            code: "unsubscribed_contacts_main_created_on",
            render: (item) => {
                return <span>{item?.createdOn && getDateFormatted(item?.createdOn, "date", "datetime", null, "UTC")}</span>
            }
        },
        {
            key: "createdBy",
            field: "createdBy",
            title: messages['unsubscribed_contacts_main_created_by'],
            show: true,
            resize: true,
            width: 200,
            export: true,
            functionString: `
                let pmUsers = ${JSON.stringify(pmUsers)}
                pmUsers = pmUsers.find((item) => ("PM_"+item.id) === row?.createdBy)
                return pmUsers.firstName + " " + pmUsers.lastName || row?.createdBy
            `,
            code: "unsubscribed_contacts_main_created_by",
            render: (item) => {
                return <span>{item?.createdBy && getPMUser(item?.createdBy, pmUsers)}</span>
            }
        }
    ])
    const [searchFields, setSearchFields] = useState(["to"]);

    useEffect(() => {
        (!pmUsers || pmUsers.length === 0) && dispatch(searchEntityRequest({ key: "pmUsers" }));
    }, []);

    useEffect(() => {
        if (pmUsers.length > 0) {
            // Use functional updater to preserve preference-restored 'show' flags
            setColumns(prev => prev.map((item) => ({
                ...item,
                title: messages[item.code],
                functionString: item.key === "createdBy" ? `
                        let pmUsers = ${JSON.stringify(pmUsers)}
                        pmUsers = pmUsers.find((item) => ("PM_"+item.id) === row?.createdBy)
                        return pmUsers.firstName + " " + pmUsers.lastName || row?.createdBy 
                `: item.functionString,
                render: item.key === "reason" ? (item) => {
                    let reasonMsg = item?.reason
                    if (item?.jsonValue && item?.reason && reportedOptions.find(x => x.id === item?.reason)) {
                        reasonMsg = messages[`unsubscribed_contacts_main_${item?.reason}`]
                    }

                    return <span>{reasonMsg || ""}</span>
                }
                    : item.key === 'reason_details' ? (item) => {
                        let title = null
                        let jsonValue = null
                        try {
                            jsonValue = item?.jsonValue
                            if (jsonValue) {
                                jsonValue = JSON.parse(JSON.parse(item?.jsonValue))
                                if (!_.isObject(jsonValue))
                                    jsonValue = JSON.parse(jsonValue)
                                title = item?.reason
                            }
                            let reported = reportedOptions.find(x => x.id == item?.reason)
                            if (jsonValue && item?.reason && reported) {
                                title = messages[`unsubscribed_contacts_main_${item?.reason}`]
                            }

                            if (title === null || typeof title === 'undefined')
                                title = messages["unsubscribed_contacts_main_details"]
                        } catch (error) {

                        }
                        return (
                            <div>
                                {
                                    item?.jsonValue &&
                                    <Tooltip title={messages["unsubscribed_contacts_main_details"]}>
                                        <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon fs-20" onClick={() => {
                                            dispatch(rawMessageViewOpenModal(true, jsonValue || "", title))
                                        }}>
                                            remove_red_eye
                                        </Icon>
                                    </Tooltip>
                                }
                            </div>
                        )
                    } : item.render
            })))
        }
    }, [pmUsers, lang])

    return (
        <Container maxWidth={false} className="container-view">
            <Paper elevation={0}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8", height: '95v' }}
                >
                    <Grid item xs={6}>
                        <Typography variant="h5" component="div">
                            {messages['unsubscribed_contacts_main_title']} {/* ({total}) */}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} style={{ display: 'flex', justifyContent: 'right' }}>
                        <Button
                            className="btn-dark-blue"
                            disabled={!HasPermission(user, "unsbctc", "c")}
                            onClick={(e) => {
                                e.preventDefault();
                                dispatch(createUnsubscribedContactOpenModal());
                            }}
                        >
                            {messages['unsubscribed_contacts_main_add_unsubscribed_contact']}
                        </Button>
                    </Grid>
                    <div style={{ width: '100%', marginBottom: 10, marginTop: 5 }}>
                        <Divider style={{ backgroundColor: '#999999' }} />
                    </div>
                    <DataViewInfiniteScroll
                        ref={tableRef}
                        infiniteScroll
                        clearOnUnmount={false}
                        entity="unsubscribedContacts"
                        name="pm-unsubscribedContacts-list"
                        tableButtons={["export", 'orderColumn']}
                        columns={columns}
                        onChangeTotal={(total) => setTotal(total)}
                        asyncSelect
                        onChangeConditions={(tags, conditions, total, newColumns, rows, sort, key, fromPreferences, restoreOnly) => {
                            // restoreOnly: data already persisted in redux, just sync UI states — skip getData
                            if (restoreOnly) return;

                            let currentConditions = {}
                            let currentTags = {}

                            if (!conditions && tags) {
                                currentConditions = tableRef?.current?.conditions;
                                currentTags = tags;
                            } else {
                                currentConditions = conditions || [];
                                currentTags = currentConditions?.filter((x) => x?.tags)[0]?.tags || [];
                                if (currentTags && currentTags.length > 0) tableRef?.current?.setTags(currentTags);
                            }

                            currentConditions = currentConditions?.filter((item) => item?.fields[0] !== 'id' && item?.fields[0] !== 'to');
                            let tagsById = currentTags.filter((item) => typeof item.id === "number");
                            if (tagsById?.length > 0) {
                                let currentIds = tagsById.map((item) => (item.id));
                                if (currentIds.length > 0) {
                                    currentConditions.push({ fields: ["id"], terms: currentIds, exact: true, tags: tagsById, conditionOperator: "OR" });
                                }
                            }
                            let tagsByLabel = currentTags.filter((item) => typeof item.id === "string");
                            if (tagsByLabel.length > 0) {
                                let currentLabels = tagsByLabel.map((item) => (item.id))
                                if (currentLabels.length > 0) {
                                    currentConditions.push({ fields: searchFields, terms: currentLabels, exact: false, tags: tagsByLabel, conditionOperator: "OR" })
                                }
                            }

                            // FIX: Always forward newSort so preference-restored sort isn't lost in tags-only branch
                            if (!conditions && tags) tableRef?.current?.getData({ newConditions: currentConditions, newSort: sort });
                            else if (!total) tableRef?.current?.getData({ newConditions: currentConditions, newRows: rows, newSort: sort });
                        }}
                        onChangeColumns={(items) => setColumns(items)}
                        options={[
                            {
                                id: "delete-unsubscribedContacts",
                                label: messages['delete'],
                                show: true,
                                multiple: true,
                                disabled: !HasPermission(user, "unsbctc", "d"),
                                action: (items) => {
                                    dispatch(deleteUnsubscribedContactOpenModal(items))
                                }
                            }
                        ]}
                        graphqlConfig={{
                            function: "searchUnsubscribedContacts",
                            sortType: "UnsubscribedContactSortInput",
                            conditionsType: "UnsubscribedContactSearchInput",
                            customQuery: "id reason, jsonValue",
                            dynamicQuery: true
                        }}
                        exportConfig={{
                            fileName: "unsubscribedcontacts"
                        }}
                        searchConfig={{
                            conditions: ["to"],
                            optionValue: "id",
                            optionLabel: "to",
                            fields: searchFields
                        }}
                        uiConfig={{
                            hideSplit: true,
                            hideFilters: true,
                            topHeight: 190,
                            hidePagination: true
                        }}
                        defaultsConfig={{
                            sort: { field: "createdOn", order: "DESC" }
                        }}
                    />
                </Grid>
            </Paper>
            {openModalCreate && <CreateUnsubscribedContact tableRef={tableRef} />}
            {openModalDelete && <DeleteUnsubscribedContact tableRef={tableRef} />}
            {open && <RawMessageView />}
        </Container>
    )
}
export default UnsubscribedContactsMain;